import { EditIcon } from "@root/assets/icons/editIcon";
import DeleteIcon from "@root/assets/icons/delete-02.svg";
import { Flex, Image, Text } from "@chakra-ui/react";
import { DELETE, EDIT } from "@root/constants";
import LinkifyText from "@root/components/common/LinkifyText";

// Accept t as an argument
export const TableColumns = (handleActions: any, t: (key: string) => string) => [
  {
    cell: (info: any) => (
      <Text style={{ textWrap: "wrap", maxWidth: "300px" }}>
        {info?.row?.original?.question || ""}
      </Text>
    ),
    header: t("faq.question"),
  },
  {
    cell: (info: any) => (
      <Text style={{ textWrap: "wrap", maxWidth: "400px", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
        <LinkifyText text={info?.row?.original?.answer || ""} />
      </Text>
    ),
    header: t("faq.answer"),
  },
  {
    cell: (info: any) => info?.row?.original?.createdAt?.split("T")[0]
 || "",
    header: t("faq.datePosted"),
  },
  {
    cell: (info: any) => (
      <Flex gap="14px">
        <Flex
          gap="8px"
          cursor="pointer"
          onClick={() => handleActions(EDIT, info?.row?.original)}
        >
          <EditIcon />
        </Flex>
        <Flex
          gap="8px"
          cursor="pointer"
          onClick={() => handleActions(DELETE, info?.row?.original)}
        >
          <Image src={DeleteIcon} width={18} />
        </Flex>
      </Flex>
    ),
    header: t("faq.actions"),
  },
];
